const map = {
	"./badge-google-play-bg.png": 35611,
	"./badge-google-play-cs.png": 6372,
	"./badge-google-play-de-AT.png": 9097,
	"./badge-google-play-hr.png": 65044,
	"./badge-google-play-hu.png": 57035,
	"./badge-google-play-ro.png": 3091,
	"./badge-google-play-sk.png": 59212
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36208;